import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function searchReducer(state = initialState.search, action) {
  switch (action.type) {
    case types.SEARCH_QUERY_SUCCESS:
      return {
        ...state,
        ...action.res.data,
        links: action.res.links,
        loading: false,
      };

    case types.GET_SECONDARY_FILTERS_SUCCESS:
      return {
        ...state,
        secondaryFilters: action.res.data,
      };

    case types.LOAD_TRENDING_SEARCHES_SUCCESS: {
      return {
        ...state,
        trendingSearches: {
          results: action.content,
          loading: false,
        },
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/searchReducer.js